import gql from "graphql-tag";

const userGroupFieldsFragment = gql`
  fragment UserGroupFields on UserGroup {
    id
    version
    status
    name
    description
  }
`;

const findUserGroupByIdQuery = gql`
  query($id: UUID) {
    findUserGroupById(id: $id) {
      ...UserGroupFields
    }
  }
  ${userGroupFieldsFragment}
`;

const findUserGroupsByNameQuery = gql`
  query findUserGroupsByName(
    $business: BusinessInput
    $name: String
    $startIndex: Int
    $stopIndex: Int
  ) {
    findUserGroupsByName(
      business: $business
      name: $name
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: { orders: [{ direction: "ASC", property: "id" }] }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        description
        name
        status
      }
    }
  }
`;

const findActiveUserGroupsQuery = gql`
  query {
    findActiveUserGroups(
      pageable: {
        startIndex: 0
        stopIndex: 50
        _type_: Range
        sort: { orders: [{ direction: "ASC", property: "name" }] }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        name
      }
    }
  }
`;

const saveUserGroupMutation = gql`
  mutation($userGroup: UserGroupInput) {
    saveUserGroup(userGroup: $userGroup) {
      ...UserGroupFields
    }
  }
  ${userGroupFieldsFragment}
`;

const deleteUserGroupMutation = gql`
  mutation($userGroup: UserGroupInput) {
    deleteUserGroup(userGroup: $userGroup) {
      id
      version
    }
  }
`;

export {
  findUserGroupByIdQuery,
  findUserGroupsByNameQuery,
  findActiveUserGroupsQuery,
  saveUserGroupMutation,
  deleteUserGroupMutation
};
